<template>
  <div class="antialiased">
    <Sidebar />

    <div class="page">
      <Header @change="_search" hint="Cari pelunasan" />

      <div class="content">
        <div class="container">
          <!-- Page title -->
          <div class="page-header">
            <div class="row d-flex justify-content-between">
              <div class="col-auto">
                <h2 class="page-title">Data Piutang</h2>
                <div>
                  Periode transaksi: {{ dataFilter.start_date }} -
                  {{ dataFilter.end_date }}
                </div>
              </div>

              <div class="col-auto">
                <div class="row">
                  <div class="col-auto px-0">
                    <div class="input-icon">
                      <span class="input-icon-addon">
                        <i class="fe fe-align-left"></i>
                      </span>
                      <select
                        class="form-control"
                        v-model="paginate.perPage"
                        @change="_get"
                        :disabled="loading"
                      >
                        <option
                          :value="num"
                          v-for="(num, i) in [10, 50, 100, 999]"
                          :key="i"
                          v-html="num === 999 ? 'Semua' : num"
                        />
                      </select>
                    </div>
                  </div>

                  <div class="col-auto">
                    <button
                      class="btn btn-white mr-3"
                      v-html="ic('filter')"
                      @click="_filter"
                    ></button>
                    <div class="btn-group">
                      <button
                        class="btn btn-outline-primary"
                        @click="_createExcel(0)"
                        :disabled="isExcelRequest || data.length == 0"
                        v-html="
                          isExcelRequest
                            ? spin()
                            : ic('download') + ' Export Excel'
                        "
                      ></button>
                      <button
                        class="btn btn-outline-primary"
                        @click="_createExcel(1)"
                        :disabled="isExcelRequestLite || data.length == 0"
                        v-html="
                          isExcelRequestLite
                            ? spin()
                            : ic('download') + ' Export Excel Lite'
                        "
                      ></button>
                      <button
                        class="btn btn-outline-primary"
                        @click="_createExcel(1, 'over-due')"
                        :disabled="isExcelRequestOverDue || data.length == 0"
                        v-html="
                          isExcelRequestOverDue
                            ? spin()
                            : ic('download') + ' Export AR Aging'
                        "
                      ></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Skeleton
            type="table"
            :length="10"
            class="mt-3 bg-white"
            v-if="loading"
          />

          <Nodata v-if="!loading && data.length === 0" />

          <div class="box" v-if="!loading && data.length > 0">
            <div class="card">
              <div class="table-respon sive">
                <table
                  class="table table-vcenter table-hover card-table table-striped"
                >
                  <thead>
                    <tr class="text-muted">
                      <th>No Invoice</th>
                      <th>Toko</th>
                      <th>Jatuh Tempo</th>
                      <th>Salesman</th>
                      <th>Jumlah Pembayaran</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(row, i) in data"
                      :key="i"
                      :class="row.over_due > 0 ? 'text-danger' : 'text-dark'"
                    >
                      <td>
                        <span
                          class="click-able"
                          @click="_detail(row)"
                          :class="
                            row.over_due > 0 ? 'text-danger' : 'text-dark'
                          "
                        >
                          {{ row.id }}
                          <br />
                          {{ row.no_invoice == null ? "" : row.no_invoice }}
                        </span>
                      </td>
                      <td>
                        <span
                          :class="
                            row.over_due > 0 ? 'text-danger' : 'text-dark'
                          "
                        >
                          [{{ row.no_acc }}]
                          <br />
                          {{ row.nama_toko }}
                        </span>
                      </td>
                      <td>
                        {{ dateFormat(row.due_date) }}
                        <br />
                        ({{ row.over_due }}
                        {{ row.over_due !== "LUNAS" ? " hari" : "" }})
                      </td>
                      <td>
                        {{ row.nama_salesman }}
                        <br />
                        ({{ row.tim }})
                      </td>
                      <td>{{ "Rp " + ribuan(row.jumlah_pembayaran) }}</td>
                      <td
                        v-html="
                          row.paid_at == null
                            ? 'Belum Lunas'
                            : '<small>Dilunasi Pada : </small><br/>' +
                              dateFormat(row.paid_at)
                        "
                      ></td>
                      <td class="p-0">
                        <b-dropdown variant="link" size="lg" dropleft no-caret>
                          <template slot="button-content">
                            <i class="fe fe-more-vertical"></i>
                          </template>
                          <b-dropdown-item @click.native="_detail(row)"
                            >Rincian</b-dropdown-item
                          >
                        </b-dropdown>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="container-fluid">
            <div class="row justify-content-center">
              <div class="col-12 col-md-auto text-center">
                <button class="btn btn-outline-primary mr-3" @click="_pagePrev">
                  Prev
                </button>
                <button class="btn btn-outline-primary" @click="_pageNext">
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <FormFilter
      :config.sync="filter.config"
      :initData="filter.data"
      :dismiss.sync="filter.dismiss"
      :isSubmit.sync="filter.isSubmit"
      @submit="filter.action"
    />

    <FormPelunasan
      :config.sync="form.config"
      :initData="form.data"
      :dismiss.sync="form.dismiss"
      :isSubmit.sync="form.isSubmit"
      @submit="form.action"
    />

    <Confirm
      :id.sync="confirm.id"
      :title.sync="confirm.title"
      :isSubmit.sync="confirm.isSubmit"
      @submit="confirm.action"
      :btnConfirm.sync="confirm.btnConfirm"
      :textConfirm.sync="confirm.textConfirm"
    />

    <DetailPelunasan
      :config.sync="detail.config"
      :initData="detail.data"
      :dismiss.sync="detail.dismiss"
      :isSubmit.sync="detail.isSubmit"
      @submit="detail.action"
    />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";
import FormPelunasan from "./modals/form-pelunasan.vue";
import DetailPelunasan from "./modals/detail-pelunasan.vue";
import XLSX from "xlsx";

const now = new Date();

export default {
  name: "Pelunasan",
  components: { FormFilter, FormPelunasan, DetailPelunasan },

  data() {
    return {
      auth: {},

      filter: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => {},
      },

      invoice: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => {},
      },

      form: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => {},
      },

      confirm: {
        id: null,
        title: null,
        isSubmit: false,
        action: () => {},
        btnConfirm: "btn-danger",
        textConfirm: "Hapus Sekarang",
      },

      detail: {
        config: { view: false, title: null },
        data: null,
        isSubmit: false,
        action: () => {},
      },

      loading: true,
      data: [],

      paginate: {
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fromPage: 0,
      },

      dataFilter: {
        perusahaan: "",
        id_salesman: "all",
        due_date: this.dateTime("ymd"),
        keyword: "",
        status: "belum_lunas",
        depo: [],
        page: "",
        per_page: "",
        tipe_pembayaran: "credit",
        id_mitra: "exclude",
        start_date: new Date(now.getFullYear(), now.getMonth() - 1, 2)
          .toISOString()
          .slice(0, 10),
        end_date: new Date(now.getFullYear(), now.getMonth() + 1, 2)
          .toISOString()
          .slice(0, 10),
        piutang_date: "",
      },

      fireTrigger: null,
      isExcelRequest: false,
      isExcelRequestLite: false,
      isExcelRequestOverDue: false,
    };
  },

  mixins: [helper],

  methods: {
    _get() {
      this.loading = true;
      this.dataFilter.id_salesman =
        this.dataFilter.id_salesman === ""
          ? "all"
          : this.dataFilter.id_salesman;
      this.dataFilter.page = this.paginate.currentPage;
      this.dataFilter.per_page = this.paginate.perPage;

      this.axios
        .get("pelunasan_penjualan", { params: this.dataFilter })
        .then((res) => {
          this.loading = false;

          this.paginate.totalRows = res.data.meta.total;
          this.data = res.data.data;
          this.paginate.to = res.data.meta.to;
        })
        .catch((err) => {
          this.loading = false;
          this.onError(err);
        });
    },

    _filter() {
      this.filter.config = { view: true, title: "Filter" };
      this.filter.action = (formData) => {
        for (const key in formData) {
          this.dataFilter[key] = formData[key];
        }
        this.paginate.currentPage = 1;
        this._get();
      };
    },

    _detail(data) {
      this.detail.config = { view: true, title: "Detail Pelunasan" };
      this.detail.data = data;
    },

    _pagePrev() {
      if (this.paginate.currentPage > 1) {
        this.paginate.currentPage--;
        this._get();
      }
    },

    _pageNext() {
      if (this.paginate.to % this.paginate.perPage == 0) {
        this.paginate.currentPage++;
        this._get();
      }
    },

    _pageChange(page) {
      this.paginate.currentPage = page;
      this._get();
    },

    _search(keyword) {
      this.dataFilter.keyword = keyword;
      this.paginate.currentPage = 1;
      this._get();
    },

    _createExcel(lite = 0, format = "normal") {
      if (lite == 0) {
        this.isExcelRequest = true;
      } else if (lite && format == "normal") {
        this.isExcelRequestLite = true;
      } else {
        this.isExcelRequestOverDue = true;
      }
      this.dataFilter.lite = lite;

      this.axios
        .get("pelunasan_penjualan/get/report_pelunasan_excel", {
          params: this.dataFilter,
        })
        .then((res) => {
          if (lite === 1) {
            this.isExcelRequestLite = false;
            this.isExcelRequestOverDue = false;
            let rspn = res.data.data;
            if (rspn.length != 0) {
              if (format == "over-due") {
                this.formatExcelOverDue({
                  data: rspn,
                  filename: "laporan-piutang-aging-" + this.dataFilter.piutang_date,
                })
              } else {
                this.formatExcel(
                  {
                    data: rspn,
                    filename: "laporan-piutang-" + this.dataFilter.piutang_date,
                  },
                  false
                );
              }
            }
          } else {
            window.open(res.data);
            this.isExcelRequest = false;
            this.isExport = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.onError(err);
        });
    },
    formatExcel(params, raw = true) {
      let dataExcel = [];
      params.data.forEach((data, i) => {
        dataExcel.push({
          No: i + 1,
          "Cust No": data.cust_no,
          "Nama Toko": data.nama_toko,
          Alamat: data.alamat,
          "Tgl Order": data.tanggal_po,
          "Tgl Deliver": data.delivered_at,
          "Due Date": data.due_date,
          "No Invoice": data.no_invoice,
          "No PO": data.no_po,
          Total: { v: data.grand_total, t: "n", w: "#.##0" },
          "Jumlah Lunas": { v: data.pembayaran, t: "n" },
          "Waiting Approve": { v: data.waiting, t: "n" },
          Sisa: { v: data.piutang, t: "n" },
          "Over Due": data.over_due,
          "Tim Lama": data.tim,
          "Tim Baru": data.tim_baru,
          "Tipe Pembayaran": data.tipe_pembayaran,
          "Depo": data.depo,
        });
      });

      const header = Object.keys(dataExcel[0]); // columns name

      var wscols = [];
      for (var i = 0; i < header.length; i++) {
        // columns length added
        wscols.push({ wch: header[i].length + 5 });
      }

      var data = XLSX.utils.json_to_sheet(dataExcel, {
        raw: raw,
        cellDates: true,
        skipHeader: false,
      });
      data["!cols"] = wscols;
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      //format
      const currency = "#,##";
      for (let col of [9, 10, 11, 12]) {
        this.formatColumn(data, col, currency);
      }

      XLSX.utils.book_append_sheet(wb, data, "Data Piutang"); // sheet is name of Worksheet
      XLSX.writeFile(wb, params.filename + ".xlsx");
    },
    formatExcelOverDue(params) {
      const data = params.data
      const columnLength = 23;
      const uniqueDepo = data.map(item => item.depo).filter((v, i, a) => a.indexOf(v) === i);
      const uniquePerusahaan = data.map(item => item.nama_perusahaan).filter((v, i, a) => a.indexOf(v) === i);
      const lengthPerusahaanDepo = uniquePerusahaan.length > uniqueDepo.length ? uniquePerusahaan.length : uniqueDepo.length;

      let rows = [];
      let row = Array(columnLength).fill("");
      row[0] = "Perusahaan";
      row[3] = "Depo";
      row[6] = "A/R AGING SCHEDULE DETAIL";
      rows.push(row);

      for (let i = 0; i < lengthPerusahaanDepo; i++) {
        // check key exist
        const perusahaan = uniquePerusahaan[i] != "undefined" ? uniquePerusahaan[i] : "";
        const depo = uniqueDepo[i] != "undefined" ? uniqueDepo[i] : "";

        if (i == 0) {
          row = Array(columnLength).fill("");
          row[0] = perusahaan;
          row[3] = depo;
          row[6] = "As of posting date";
          row[7] = this.formatDateNow();
          rows.push(row);
        } else {
          row = Array(columnLength).fill("");
          row[0] = perusahaan;
          row[3] = depo;
          rows.push(row);
        }
      }

      // blank row
      rows.push(Array(columnLength).fill(""));
      let headerStart = lengthPerusahaanDepo + 2;
      let headerEnd = headerStart + 1;
      // header
      row = Array(columnLength).fill("");
      row[0] = "No";
      row[1] = "No PO";
      row[2] = "No Invoice";
      row[3] = "Tgl Order";
      row[4] = "Tgl Deliver";
      row[5] = "Tipe Pembayaran";
      row[6] = "Due Date";
      row[7] = "Cust No";
      row[8] = "Nama Toko";
      row[9] = "Alamat";
      row[10] = "Tim Lama";
      row[11] = "Tim Baru";
      row[12] = "Depo";
      row[13] = "Total Invoice";
      row[14] = "Jumlah Lunas";
      row[15] = "Jumlah Waiting";
      row[16] = "Belum Over Due";
      row[17] = "Over Due";
      rows.push(row);

      row = Array(columnLength).fill("");
      row[17] = "1 - 10 hari";
      row[18] = "11 - 20 hari";
      row[19] = "21 - 30 hari";
      row[20] = "31 - 60 hari";
      row[21] = "61 - 90 hari";
      row[22] = ">90hari";
      rows.push(row);

      for (let i = 0; i < data.length; i++) {
        let row = data[i];

        let value = [
          i + 1,
          row.no_po,
          row.no_invoice,
          row.tanggal_po,
          row.delivered_at,
          row.tipe_pembayaran,
          row.due_date,
          row.no_acc,
          row.nama_toko,
          row.alamat,
          row.tim,
          row.tim_baru,
          row.depo,
          row.grand_total,
          row.pembayaran,
          row.waiting,
          "",
          "",
          "",
          "",
          "",
          "",
          ""
        ];

        // over due
        if (row.over_due <= 0) {
          value[16] = row.piutang;
        }

        // aging
        if (row.over_due > 0 && row.over_due <= 10) {
          value[17] = row.piutang;
        }

        if (row.over_due > 10 && row.over_due <= 20) {
          value[18] = row.piutang;
        }

        if (row.over_due > 20 && row.over_due <= 30) {
          value[19] = row.piutang;
        }

        if (row.over_due > 30 && row.over_due <= 60) {
          value[20] = row.piutang;
        }

        if (row.over_due > 60 && row.over_due <= 90) {
          value[21] = row.piutang;
        }

        if (row.over_due > 90) {
          value[22] = row.piutang;
        }
        
        rows.push(value)
      }

      let dataLength = data.length;
      let sumStart = headerEnd + 2;
      let sumEnd = sumStart + dataLength - 1;
      rows.push([
        "", "", "", "", "", "", "", "", "", "", "", "", "",
        {
          t: "n",
          f: `SUM(N${sumStart}:N${sumEnd})`,
        },
        {
          t: "n",
          f: `SUM(O${sumStart}:O${sumEnd})`,
        },
        {
          t: "n",
          f: `SUM(P${sumStart}:P${sumEnd})`,
        },
        {
          t: "n",
          f: `SUM(Q${sumStart}:Q${sumEnd})`,
        },
        {
          t: "n",
          f: `SUM(R${sumStart}:R${sumEnd})`,
        },
        {
          t: "n",
          f: `SUM(S${sumStart}:S${sumEnd})`,
        },
        {
          t: "n",
          f: `SUM(T${sumStart}:T${sumEnd})`,
        },
        {
          t: "n",
          f: `SUM(U${sumStart}:U${sumEnd})`,
        },
        {
          t: "n",
          f: `SUM(V${sumStart}:V${sumEnd})`,
        },
        {
          t: "n",
          f: `SUM(W${sumStart}:W${sumEnd})`,
        },
      ]);

      var ws = XLSX.utils.aoa_to_sheet(rows);

      // merge header
      ws["!merges"] = [];
      // merge row 1 - 17
      for (let i = 0; i <= 16; i++) {
        ws["!merges"].push({ s: { r: headerStart, c: i }, e: { r: headerEnd, c: i } });
      }

      ws["!merges"].push(
        { s: { r: headerStart, c: 17 }, e: { r: headerStart, c: 22 } }, // R1:W1
      );

      /* create workbook and export */
      var wb = XLSX.utils.book_new();
      
      // center
      const range = XLSX.utils.decode_range(ws['!ref']);
      for(let R = range.s.r; R <= range.e.r; R++) {
          let cell_address = XLSX.utils.encode_cell({c: 1, r: R}); // Column B is index 1
          if(!ws[cell_address]) continue; // Skip if the cell is not defined

          if(!ws[cell_address].s) ws[cell_address].s = {};
          ws[cell_address].s.alignment = { horizontal: "center" };
      }

      const currency = "#,##";
      let worksheet = ws;
      for (let col of [13, 14, 15, 16, 17, 18, 19, 20, 21, 22]) {
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        // note: range.s.r + 1 skips the header row
        for (let row = range.s.r + headerEnd + 1; row <= range.e.r; ++row) {
          const ref = XLSX.utils.encode_cell({ r: row, c: col });
          if (worksheet[ref] && worksheet[ref].t === "n") {
            worksheet[ref].z = currency;;
          }
        }
      }

      // set column width
      if(!ws["!cols"]) ws["!cols"] = [];
      for (let col of [2, 7, 8, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22]) {
        if(!ws["!cols"][col]) ws["!cols"][col] = {wch: 8};
        ws["!cols"][col].wpx = 100;
      }

      for (let col of [8]) {
        if(!ws["!cols"][col]) ws["!cols"][col] = {wch: 8};
        ws["!cols"][col].wpx = 150;
      }
      
      XLSX.utils.book_append_sheet(wb, ws, "Data Piutang");
      XLSX.writeFile(wb, params.filename + ".xlsx");
    },
    formatColumn(worksheet, col, fmt) {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      // note: range.s.r + 1 skips the header row
      for (let row = range.s.r + 1; row <= range.e.r; ++row) {
        const ref = XLSX.utils.encode_cell({ r: row, c: col });
        if (worksheet[ref] && worksheet[ref].t === "n") {
          worksheet[ref].z = fmt;
        }
      }
    },
    formatDateNow() {
      const now = new Date();

      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  },

  mounted() {
    this.auth = JSON.parse(localStorage.user);
    this._get();
  },

  watch: {
    fireTrigger() {
      this._get();
    },
  },
};
</script>
